import React from 'react';
import v4 from 'uuid/v4';

export default function ForEach({ items, render, style }) {
  if (Array.isArray(items) === false) return null;
  return items.map((element, i) => <div style={style} key={v4()}>{render(element, i)}</div>);
}
